<template>
  <BaseViewComponent
    name="overview"
    :is-preview="isPreview"
  >
    <div class="overview-wrapper full-width flex justify-between items-center">
      <div class="container">
        <div class="flex justify-between">
          <div class="left">
            <div class="title-h2">
              {{ pageData.overviewTitle }}
            </div>
            <div class="text-p">
              {{ pageData.overviewDescription }}
            </div>
          </div>
          <div class="right">
            <div class="relative-position images-wrapper">
              <img
                class="border-radius-16 left-image"
                :src="overviewImageLeft ? getCompressImage(overviewImageLeft) : '/landing/overview-cover.png'"
              >
              <img
                class="border-radius-16 absolute right-image"
                :src="overviewImageRight ? getCompressImage(overviewImageRight) : '/landing/overview-cover.png'"
              >
            </div>
          </div>
        </div>
        <div class="flex items">
          <div
            v-for="(item, index) in pageData.overviewItems"
            :key="index"
            class="item flex no-wrap border-radius-16"
          >
            <q-icon
              :name="item.icon"
              class="icon"
            />
            <div>
              <div class="title-h4 q-mb-sm">{{ item.title }}</div>
              <div class="note-p">{{ item.description }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </BaseViewComponent>
</template>

<script setup>
import BaseViewComponent from 'components/book-landing/render/BaseViewComponent.vue';
import useBookPageEdit from 'src/composables/useBookPageEdit';
import { useBookPageStore } from 'stores/bookPage';
import { storeToRefs } from 'pinia';
import getCompressImage from 'src/helpers/getCompressImage';

defineProps({
  isPreview: {
    type: Boolean,
    default: false,
  },
});

const {
  overviewImageLeft,
  overviewImageRight,
} = useBookPageEdit();

const bookPageStore = useBookPageStore();
const { pageData } = storeToRefs(bookPageStore);
</script>

<style lang="scss" scoped>
</style>
